var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomerService(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 1.93213C11.191 1.93213 13.7773 4.51849 13.7773 7.70947V13.689H10.4443C9.83074 13.6889 9.33301 13.1912 9.33301 12.5776V9.02197C9.3331 8.40843 9.83079 7.9107 10.4443 7.91064H12.4443V7.70947C12.4443 5.25487 10.4546 3.26514 8 3.26514C5.5454 3.26514 3.55566 5.25487 3.55566 7.70947V7.91064H5.55566C6.16921 7.9107 6.6669 8.40843 6.66699 9.02197V12.5776C6.66699 13.1913 6.16926 13.6889 5.55566 13.689H2.22266V7.70947C2.22266 4.51849 4.80902 1.93213 8 1.93213ZM3.55566 12.356H5.33301V9.24463H3.55566V12.356ZM10.667 12.356H12.4443V9.24463H10.667V12.356Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerService);
export default __webpack_public_path__ + "static/media/customerService.74b8645588258828c6d1df90ed446312.svg";
export { ForwardRef as ReactComponent };